import { getApi, postApi, putApi } from "@/utils/http";
export const getCityData = () => {
  return getApi("/video/poi/city/data");
};

// 根据关键词搜索位置列表
export const getPositionByKeywordApi = (params) => {
  return getApi('/video/poi/search', params)
}

// 获取快手网页授权地址
export const getKuaishouApi = () => {
  return getApi('/video/auth/kuaishou')
}

// 获取tiktok地址
export const getTikTokApi = () => {
  return getApi('/video/auth/tiktok')
}

// 获取抖音授权地址
export const getDouyinApi = () => {
  return getApi('/video/auth/douyin')
}

// 获取用户信息
export const getUserInfo = () => {
  return getApi('/user/info')
}

// 获取快手创建授权
export const addKuaishouAuthApi = (data) => {
  return postApi('/video/auth/kuaishou/callback',  data)
}
// 获取抖音创建授权
export const addDouyinAuthApi = (data) => {
  return postApi('/video/auth/douyin/callback',  data)
}

// 获取tiktok创建授权
export const addTiktokAuthApi = (data) => {
  return postApi('/video/auth/tiktok/callback', data)
}


// 获取用户头像
export async function getUserAvatarUrl(url: string): Promise<any> {
  return getApi(`/space/oss/url?oss_key=${url}`);
}

// 获取二维码地址
export async function getCode(id: string): Promise<any> {
  return getApi(`/video/task/code?task_id=${id}`);
}

//修改poi门店地址
export function patchAddressApi({id, data}): Promise<any> {
  return putApi(`/video/auth/${id}/address`, data);
}
